/**
 * Exports all versions and metadata for the Terms of Service
 * Version history documentation began in February 2025
 */

import { type Version } from "../types";
import { current } from "./current";

// List versions in order of newest to oldest
export const versions: Record<string, Version> = {
  current: {
    content: current,
    date: "November 1, 2023",
  },
};

// Version history excludes the current version
// List in order of newest to oldest
// export const versionHistory: VersionHistoryEntry[] = [];

export const currentVersion = versions.current;
